import { core } from '@/core'
import Basic from '@basic'
import compile from '@/core/compile'

const util = {
  pullComponents(opt, tar) {
    const { content } = tar.members
    const item = compile.getItem(opt)
    content.append(item.item.unit)
    tar.unit.addClass(`file-item__${item.type}`)
    return item
  },
  template: {
    item() {
      return $(`
      <div class="file-item">
        <span id="span" class="file-item__span"></span>
        <div id="content" class="file-item__content"></div>
      </div>`)
    }
  },
  updater: {
    // 原生属性: name
    hide(value, opt, tar, node) {
      if (value) {
        tar.unit.addClass('is-hidden')
      } else {
        tar.unit.removeClass('is-hidden')
      }
    },
    // 原生属性: disabled
    disabled(value, opt, tar, node) {
      if (value) {
        tar.unit.addClass('is-disabled')
      } else {
        tar.unit.removeClass('is-disabled')
      }
    },
    // 基本功能: view
    view(value, opt, tar, node) {
      if (value) {
        tar.unit.addClass('is-view')
      } else {
        tar.unit.removeClass('is-view')
      }
    },
    class(value, opt, tar, node) {
      tar.unit.addClass(value)
    }
  }
}

export default class OfficeItem extends Basic {
  constructor(opt) {
    super(opt)
    const def = {
      placeholder: '',
      hasPlaceholder: false
    }
    this.defaults = {
      class: '',
      disabled: false, // 基本功能: 禁用/启用
      view: false, // 基本功能: 查看/编辑
      hide: false // 基本功能: 隐藏/显示
    }
    this.events = {
      focus: 'onFocus',
      blur: 'onBlur',
      keyup: 'onKeyup',
      change: 'onChange',
      input: 'onInput',
      hidden: 'onHidden',
      click: null
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.item(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    const item = util.pullComponents(opt, this)
    Object.assign(this, item)
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    const item = this.item
    $.type(item.input) === 'function' && item.input($.proxy(this.input, this))
    $.type(item.keyup) === 'function' && item.keyup($.proxy(this.keyup, this))
    $.type(item.change) === 'function' && item.change($.proxy(this.change, this))
    $.type(item.hidden) === 'function' && item.hidden($.proxy(this.hidden, this))
    $.type(item.focus) === 'function' && item.focus($.proxy(this.focus, this))
    $.type(item.blur) === 'function' && item.blur($.proxy(this.blur, this))
    this.unit.click($.proxy(this.click, this))
  }

  onInput(tar) {
    this.value = tar.value
  }

  onChange(tar, item) {
    this.value = tar.value
    this.unit.removeClass('type-in')
  }

  onHidden(tar, item) {
    this.value = tar.value
    this.unit.removeClass('type-in')
  }

  onKeyup(tar, item) {
    this.value = tar.value
  }

  onFocus(tar, item) {
    this.unit.addClass('type-in')
  }

  onBlur(target, item) {
    const { span, content } = this.members
    this.unit.removeClass('type-in')
    content.width(span.width())
  }

  set value(value) {
    const { span, content } = this.members
    const item = this.item
    item.value = value
    const placeholder = this.placeholder
    const spanText = this.item.textContent || placeholder
    span.html(spanText || Array(16).fill('&nbsp;').join(''))
    const height = span.height()
    const ch = content.height()
    if (height * 2 < ch) {
      const width = span.width() ? span.width() + 10 : 72 + 10
      content.width(width)
    } else {
      const width = span.width() ? span.width() + 10 : 36 + 10
      content.width(width)
    }
  }

  get value() {
    return this.item.value
  }

  get placeholder() {
    const placeholder = this.settings.hasPlaceholder && String(this.settings.placeholder).trim()
    if (!this.item.textContent && placeholder) {
      this.unit.addClass('is-placeholder')
    } else {
      this.unit.removeClass('is-placeholder')
    }
    return placeholder
  }
}
